import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from '@core/app-config';
import { OAuthTokenService } from '@core/oauth-shared/oauth-token.service';
import { mergeMap } from 'rxjs/operators';

export function setupSubmission<P>(
  deps: {
    httpClient: HttpClient;
    appConfig: AppConfigService;
    oAuthTokenService: OAuthTokenService;
  },
  endpointUrl: string,
) {
  const { httpClient, appConfig, oAuthTokenService } = deps;

  const callAPI = ({ requestBody, tokenResponse }) => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      ...OAuthTokenService.extractTokenFromResponse(tokenResponse),
    });

    return httpClient.post(endpointUrl, requestBody, {
      headers,
      observe: 'body',
    });
  };

  return (requestBody: P) => {
    // Group travel uses the same resource/enpoint as contactus.
    // We can refactor this piece if/when we want to reuse it on non-DCR pages.
    const { clientSecret, clientId, resource } = appConfig.contactUs.oauth;

    return oAuthTokenService
      .postTokenRequest({
        resource,
        clientId,
        clientSecret,
      })
      .pipe(mergeMap(tokenResponse => callAPI({ requestBody, tokenResponse })));
  };
}
